/**
 * Image with a built-in graceful fallback. If the remote (CDN) image fails to load, the
 * element collapses to a branded pine→gold gradient instead of a broken-image icon, so
 * the layout never degrades. Lazy-loaded and async-decoded by default.
 */
import { useState } from 'react';
import { img } from '../../data/media.js';
import styles from './Figure.module.css';

export function Figure({
  id,
  alt = '',
  w = 1200,
  h,
  className = '',
  rounded = true,
  ratio,
  caption,
  eager = false,
  children,
}) {
  const [failed, setFailed] = useState(false);
  const style = ratio ? { aspectRatio: ratio } : undefined;

  return (
    <figure
      className={`${styles.figure} ${rounded ? styles.rounded : ''} ${failed ? styles.failed : ''} ${className}`}
      style={style}
    >
      {!failed && (
        <img
          src={img(id, w, h)}
          alt={alt}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          className={styles.img}
          onError={() => setFailed(true)}
        />
      )}
      {children}
      {caption && <figcaption className={styles.caption}>{caption}</figcaption>}
    </figure>
  );
}

export default Figure;
